import React from 'react';
import { Col, Button, Form, Select, DatePicker } from 'antd';
import moment from 'moment';

const ReportsForm = ({ formname, formData, setFormData, onHndleFinish }) => {

    const handleSelectChange = (value, name) => {
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleDateChange = (date, dateString) => {
        setFormData({
            ...formData,
            date: dateString,
        });
    };

    return (          
        <Form
            name={formname}
            layout="inline"
            onFinish={onHndleFinish}
            className='filterTabs'
            style={{ width: '100%', paddingTop: '25px', paddingBottom: '25px', justifyContent: 'start', backgroundColor: '#FFF' }}
        >
            <Col span={4} xs={24} sm={24} lg={24} xl={16} style={{ textAlign: 'start' }}>
                <Form.Item label="Select Organization" style={{ width: '100%', margin: 0 }}>
                    <Select
                        onChange={(value) => handleSelectChange(value, 'organization')}
                        placeholder="Select"
                        value={formData.organization}
                        options={[
                            {
                                value: 'bio-net',
                                label: 'BIO-NET',
                            },
                            {
                                value: 'lucy',
                                label: 'Lucy',
                            },
                        ]}
                    />
                </Form.Item>
            </Col>
            <hr />
            <Col span={4} xs={24} sm={24} lg={24} xl={16} style={{ textAlign: 'start' }}>
                <Form.Item label="Select Region" style={{ width: '100%', marginBottom: 20 }}>
                    <Select
                        onChange={(value) => handleSelectChange(value, 'region')}
                        placeholder="Select"
                        value={formData.region}
                        options={[
                            {
                                value: 'Greece',
                                label: 'Greece',
                            },
                            {
                                value: 'Cyprus',
                                label: 'Cyprus',
                            },
                        ]}
                    />
                </Form.Item>
                <Form.Item label="Select Product" style={{ width: '100%', marginBottom: 20 }}>
                    <Select
                        onChange={(value) => handleSelectChange(value, 'product')}
                        placeholder="Select"
                        value={formData.product}
                        options={[
                            {
                                value: 'Oranges',
                                label: 'Oranges',
                            },
                            {
                                value: 'Apples',
                                label: 'Apples',
                            },
                        ]}
                    />
                </Form.Item>
                <Form.Item label="Select Date" style={{ width: '100%', marginBottom: 20 }}>
                    <DatePicker
                        value={formData.date ? moment(formData.date) : null}
                        onChange={handleDateChange}
                        style={{
                            width: '100%',
                        }} />
                </Form.Item>
                <Form.Item style={{ width: '100%', alignItems: 'start' }}>
                    <Button className="btnPrimary" type="primary" htmlType="submit" style={{ padding: '22px 20px', backgroundColor: '#335001' }}>Filter</Button>
                </Form.Item>
            </Col>
        </Form>
    );
}

export default ReportsForm;
